import('./editable_label.css')

export default function EditableLable(opts){
    BaseConstructor.call(this)
    let context = this
    let elements = {}
    let{text_wrapper = 'label', text, input_type = "input"} = opts
    let button_options = opts.button_options || {potision:'right', icon_edit: '<i class="fas fa-pencil-alt"></i>', icon_confim: '<i class="fas fa-check"></i>'}
    let text_options = opts.text_options || {}
    let state = {
        editing: false
    }

    this.getElement = _ =>{
        return elements.container
    }

    this.setText = new_text =>{
        text = new_text
        init()
    }

    init()

    function init(){
        elements.container = context.createElement('div', 'editable-label-container')
        elements.label_container = context.createElement('div', 'w-100')
        elements.edit_button_container = context.createElement('div')
        updateButton()
        updateLabel()
        $(elements.container).append(elements.label_container, elements.edit_button_container)

        eventsHandler()
    }

    function eventsHandler(){
        
    }

    function updateButton(){
        elements.edit_button = context.createElement('button', `editable-label-button ${state.editing ? 'confirm' : ''}`, (state.editing ? button_options.icon_confim : button_options.icon_edit))
        $(elements.edit_button_container).html(elements.edit_button)

        $(elements.edit_button).on('click', () =>{
            syncData()
            state.editing = !state.editing
            updateButton()
            updateLabel()
        })
    }

    function updateLabel(){
        elements.label = state.editing ? context.createElement(input_type, 'editable-label-input w-100') : context.createElement(text_wrapper, 'w-100', text)

        if(text_options.customClass){
            $(elements.label).toggleClass(text_options.customClass, true)
        }
        
        $(elements.label).attr('title', text_options.attr_title)

        if(state.editing){
            if(input_type === 'input'){
                elements.label.value = text
            } else if (input_type === 'textarea'){
                $(elements.label).html(text)
            }
            
        }
        $(elements.label_container).html(elements.label)
    }

    function syncData(){
        if(state.editing){
            let value = elements.label.value
            let previous = text
            text = value
            context.trigger('value-updated', {previous: previous, current: text})
        }
    }
}

EditableLable.prototype = Object.create(BaseConstructor.prototype)